import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Founder from "@/components/sections/Founder";
import Services from "@/components/sections/Services";
import QuickQuote from "@/components/sections/QuickQuote";
import WhyChooseUs from "@/components/sections/WhyChooseUs";
import CallToAction from "@/components/sections/CallToAction";
import Booking from "@/components/sections/Booking";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import ContactWidget from "@/components/sections/ContactWidget";

export default function HomePage() {
  return (
    <main className="min-h-screen bg-[#F8FAFC] text-[#0F2942]" data-testid="home-page">
      <Header />
      <Hero />
      <About />
      <Founder />
      <Services />
      <QuickQuote />
      <WhyChooseUs />
      <CallToAction />
      <Booking />
      <FAQ />
      <Contact />
      <Footer />
      <ContactWidget />
    </main>
  );
}
